var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43082 13.3502L1.78741 9.12561C5.21296 2.42013 12.7793 -1.15919 20.3245 0.337517C22.9645 0.861319 25.8838 2.25678 27.8477 4.06893C27.917 4.13283 28.1035 4.27098 28.0562 4.36143L23.2755 9.03291C22.3214 8.20625 21.24 7.50785 20.025 7.10285C14.7445 5.34289 9.17046 8.27015 7.43036 13.3507L7.43082 13.3502Z",
    fill: "#E94335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43078 19.6426C9.47959 25.7293 17.0289 28.4514 22.5253 24.8113L27.985 28.9909C24.1828 32.4136 18.718 33.6259 13.6695 32.6998C8.57141 31.7647 4.08655 28.3992 1.78784 23.8672L7.43124 19.6426H7.43078Z",
    fill: "#34A753"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5253 24.811C24.264 23.6594 25.4722 21.9467 25.8746 19.9123H16.8364V13.4854H32.711C33.6628 19.0555 32.3136 25.0945 27.9854 28.9911L22.5258 24.8115L22.5253 24.811Z",
    fill: "#4284F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43077 13.3504C6.71093 15.4514 6.72333 17.5403 7.43077 19.6427L1.78737 23.8674C-0.587594 19.1851 -0.604132 13.8076 1.78737 9.12573L7.43077 13.3504Z",
    fill: "#FABB05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2d5759ea492e1f3527aeff36a287223a.svg";
export { ForwardRef as ReactComponent };